import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { LoginService } from 'src/app/services/login.service'
import { WEBSITE_URL } from 'src/app/shared/constants/website-constant'

@Component({
  selector: 'app-recovery-pin',
  templateUrl: './recovery-pin.component.html',
  styleUrls: ['./recovery-pin.component.less'],
})
export class RecoveryPinComponent implements OnInit {
  @Output() back = new EventEmitter()
  @Output() recoveryCodeVerified = new EventEmitter()
  @Input() MFAData!: any
  recoveryPin = ''
  codeError = false
  verifyButtonDisabled = true
  constructor(private loginService: LoginService) {}
  logoURL = '../assets/images/logo.svg'
  webURL: string = WEBSITE_URL
  ngOnInit(): void {}

  onPinChange(pin: any) {
    this.recoveryPin = pin
    this.codeError = false
    if (pin.toString().length === 12 && this.verifyButtonDisabled === true) {
      this.verifyButtonDisabled = false
      this.loginWithRecoveryPin(pin)
    } else if (pin.toString().length !== 12) {
      this.verifyButtonDisabled = true
    }
  }

  /**
   * Logins with recovery pin
   */
  loginWithRecoveryPin(pin: any) {
    const payload = {
      member_id: this.MFAData?.member_id,
      recovery_code: pin,
      member_email: this.MFAData?.member_email ?? '',
      member_password: this.MFAData?.member_password ?? '',
    }
    this.loginService.verifyRecoveryCode(payload).subscribe({
      next: (res: any) => {
        this.recoveryCodeVerified.emit(res)
      },
      error: () => {
        this.codeError = true
      },
    })
  }

  contactSupport() {
    location.href = 'mailto:help@v-comply.com?subject=Help needed: Unable to log in with recovery code'
  }
}
